import styled from "styled-components"
import { tablet, mobile } from "../../Responsive"

export const Wrapper = styled.div`
    margin-top: 30px;
`

export const Title = styled.h1`
    font-size: var(--fontL);
    font-weight: 400;
    margin-bottom: 10px;
`

export const Form = styled.div`
    display: flex;
    flex-wrap: wrap;
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;

    ${tablet({ width: "300px" })}
    ${mobile({ width: "250px" })}
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
    color: var(--${props => props.color});

    ${({ color }) => color === "secondary" && "font-weight: 600;"};
`

export const StyledInput = styled.input`
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-size: var(--fontS);
    border: none;
    border-bottom: 1px solid var(--primary);
    border-radius: 5px;
    height: 30px;

    ::placeholder{
        color: ${({ theme }) => theme.text};
    }

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const StyledTextArea = styled.textarea`
    width: 400px;
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    border: 1px solid var(--primary);
    border-radius: 5px;
    height: 100px;

    ::placeholder{
        color: ${({ theme }) => theme.text};
    }

    :focus{
        border: 1px solid var(--secondary);
        outline: none;
    }

    ${tablet({ width: "300px" })}
    ${mobile({ width: "250px" })}
`